module.exports = __webpack_public_path__ + "static/logo-sketches-6706976fad245ac92a9dd985306d2d0c.png";